import React, { ReactNode } from 'react';
import { CancelIcon } from './CancelIcon';

type ModalProps = {
	children: ReactNode;
};
declare global {
	interface Window {
		CobuyrWidget?: {
			closeWidget?: () => void;
		};
	}
}

export default function Modal({ children }: ModalProps) {
	const handleClose = () => {
		if (window.parent && window.parent !== window) {
			window.parent.postMessage(JSON.stringify({ action: 'close' }), '*');
			return;
		}

		window.CobuyrWidget?.closeWidget?.();
	};

	return (
		<>
			<div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
				<div className="relative md:w-9/12 w-11/12 my-6 mx-auto max-w-11/12 md:max-h-[90vh] max-h-[95vh] md:mt-0 overflow-auto">
					<div className="w-full mb-4 flex justify-end">
						<button
							type="button"
							className="w-[100px] bg-white flex items-center justify-center py-3 px-3 rounded-lg cursor-pointer"
							onClick={handleClose}
						>
							<CancelIcon />

							<p className="text-medium font-semibold">Close</p>
						</button>
					</div>
					{/*content*/}
					<div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
						<div className="relative p-6 flex-auto">{children}</div>
					</div>
				</div>
			</div>
			<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
		</>
	);
}
